import type { BillOfSaleEvent } from '@avisoma/shared';

export type BillOfSalePresentationRow = BillOfSaleEvent & {
  pageId?: string;
  isDocumentSigned?: boolean;
};

export function presentBillOfSaleRows<T extends BillOfSaleEvent>(
  rows: readonly T[],
  isDocumentSigned: boolean | undefined,
): Array<T & { isDocumentSigned: boolean | undefined }> {
  return rows.map((row) => ({ ...row, isDocumentSigned }));
}

export function formatBillOfSaleSigned(
  isDocumentSigned: boolean | undefined,
): 'Yes' | 'No' | '—' {
  if (isDocumentSigned === undefined) return '—';
  return isDocumentSigned ? 'Yes' : 'No';
}
